import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import useNavigateWithBase from "../hooks/useNavigateWithBase"; // ✅ 新しいフックをインポート
import { getRoleName } from '../components/UserRoleBadge';
import '../CSS/EditUser.css'; // ✅ CSS を適用

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigateWithBase();
  const [user, setUser] = useState({});
  const [role, setRole] = useState('1.0');
  const companyCode = localStorage.getItem('company_code'); // ✅ localStorage から取得
  const currentUserRole = parseFloat(localStorage.getItem('role')) || 0;

  useEffect(() => {
    const requestData = {
      action: "get_user",
      company_code: companyCode,
      user: { personal_id: id } // ✅ user オブジェクト内に personal_id を格納
    };
  
    axios.post("https://hmr25alvt7.execute-api.ap-northeast-3.amazonaws.com/prod/api/users", requestData)
      .then(response => {
        console.log('✅ 取得したユーザーデータ:', response.data);
        if (response.data) {
          setUser(response.data);
          setRole(response.data.role);
        }
      })
      .catch(error => console.error('❌ 取得エラー', error));
  }, [id, companyCode]); // ✅ ここで useEffect() を閉じる

  // 🔹 ユーザー情報の更新（バックエンドに合わせて `POST` リクエストに変更）
  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestData = {
      action: "edit",
      company_code: companyCode,
      user: {
        personal_id: user.personal_id, // ✅ 個人IDは変更不可
        name: user.name,
        email: user.email,
        role: role
      }
    };

    try {
      const response = await axios.post(
        "https://hmr25alvt7.execute-api.ap-northeast-3.amazonaws.com/prod/api/users",
        requestData,
        { timeout: 10000, withCredentials: false }
      );

      alert(response.data.message);
      navigate('/portal');

    } catch (error) {
      alert("更新に失敗しました。");
    }
  };

  // 🔹 現在のユーザー権限以下の選択肢のみを表示
  const availableRoles = [
    { value: 1.0, label: getRoleName(1.0) },
    { value: 5.0, label: getRoleName(5.0) },
    { value: 5.5, label: getRoleName(5.5) },
    { value: 9.0, label: getRoleName(9.0) }
  ].filter(roleOption => roleOption.value <= currentUserRole);

  return (
    <div className="edit-user-container">
      <h1 className="edit-user-title">利用者編集</h1>
      <form className="edit-user-form" onSubmit={handleSubmit}>
        <label>個人ID:</label>
        <input type="text" className="edit-user-input" value={user.personal_id || ''} disabled />
        
        <label>名前:</label>
        <input type="text" className="edit-user-input" value={user.name || ''} onChange={e => setUser({ ...user, name: e.target.value })} />

        <label>メール:</label>
        <input type="email" className="edit-user-input" value={user.email || ''} onChange={e => setUser({ ...user, email: e.target.value })} />

        <label>権限:</label>
        <select className="edit-user-select" value={role} onChange={e => setRole(e.target.value)}>
          {availableRoles.map(roleOption => (
            <option key={roleOption.value} value={roleOption.value}>{roleOption.label}</option>
          ))}
        </select>

        <div className="edit-user-buttons">
          <button type="submit" className="edit-user-button submit">更新</button>
          <button type="button" className="edit-user-button cancel" onClick={() => navigate('/portal')}>ポータルへ戻る</button>
        </div>
      </form>
    </div>
  );
};

export default EditUser;
